import { getChatSession } from '@/lib/chat-session-storage'

export const CHAT_SIDEBAR_OPEN_KEY = 'chatSidebarOpen'

/** Initial open state: localStorage flag, else open when a session exists in sessionStorage. */
export function getStoredChatSidebarOpen(): boolean {
  if (typeof window === 'undefined') return false
  try {
    if (localStorage.getItem(CHAT_SIDEBAR_OPEN_KEY) === 'true') return true
  } catch {
    /* ignore */
  }
  return getChatSession() !== null
}

export function setStoredChatSidebarOpen(open: boolean): void {
  try {
    localStorage.setItem(CHAT_SIDEBAR_OPEN_KEY, String(open))
  } catch {
    /* ignore */
  }
}
